export default __webpack_public_path__ + "static/media/intervention_vide.86875dd6.svg";